import logo from './Img/logo.png'
import es from './Img/bandera_espanhol.png'
import en from './Img/bandera_ingles.png'
import ic_user from "./Img/ic_user.png"
import './App.css'
import axios from 'axios'
import { useLocation,useNavigate } from 'react-router-dom'
import React,{ useEffect,useRef,useState } from 'react'
import { url,reemplazarAcentos } from './Funciones.js'
import Enlaces from './Componentes/Enlaces.jsx'
import EnlacesGRP from './Componentes/EnlacesGRP.jsx'
import Inicio from './Componentes/Inicio.jsx'
import ProductosServicios from './Componentes/ProductosServicios.jsx'
import Contacto from './Componentes/Contacto.jsx'
import Mapa from './Componentes/Mapa.jsx'
import NoEncontrado from './Componentes/NoEncontrado.jsx'
import Login from './Componentes/Login.jsx'
import Register from './Componentes/Register.jsx'
import DatosUsuario from './Componentes/DatosUsuario.jsx'
import Clientes from './Componentes/Clientes.jsx'
import Centros from './Componentes/Centros.jsx'
import Proyectos from './Componentes/Proyectos.jsx'
import Registros from './Componentes/Registros.jsx'
function App() {
  const location=useLocation()
  const grp=location.pathname.startsWith("/grp")
  const api=location.pathname.startsWith("/api/")
  const idioma=localStorage.getItem("idioma") || "es"
  const [show,setShow]=useState(false)
  const [subshow,setSubShow]=useState(false)
  const [useroptions,setUseroptions]=useState(false)
  const mainRef = useRef(null)
  const linksicon=useRef(null)
  const navigate=useNavigate()
  const[log,setLog]=useState(JSON.parse(localStorage.getItem("log"))!=null?JSON.parse(localStorage.getItem("log")):null)
  const [perfil,setPerfil] = useState(log!=null && log.perfil!=null?log.perfil:null)
  const enlaces=["Inicio","Productos y Servicios","Contacto"]
  const enlaces_en=["Home","Products & Services","Contact"]
  const subenlaces=["asiCP Control de Producción","asiPROC Control de Procesos","asiQ Control de Calidad","asiAut Automatización"]
  const subenlaces_en=["asiCP Production Control","asiPROC Process Control","asiQ Quality Control","asiAut Automation"]
  const pages=[<Inicio subenlaces={subenlaces} subenlaces_en={subenlaces_en}/>,<ProductosServicios subenlaces={subenlaces} subenlaces_en={subenlaces_en}/>,<Contacto/>]
  const grpages=log!=null?[<Clientes usuario={log}/>,<Centros usuario={log}/>,<Proyectos usuario={log}/>,<Registros usuario={log}/>]:[<Login setLog={setLog}/>,<Register setLog={setLog}/>]
  const enlaces_grp=log!=null?["Clientes","Centros","Proyectos","Registros"]:["Iniciar Sesión","Registrar"]
  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollTo(0, 0)
      setShow(false)
      setSubShow(false)
    }
    const observer = new ResizeObserver(() => {
      if (!grp && !api){
        const isVisible = linksicon.current.offsetParent !== null
        if (!isVisible){
          setShow(false)
          setSubShow(false)
        }
      }
    });
    observer.observe(document.body)
  },[location])
  useEffect(()=>{
    if (grp){
      if (log!=null){
      axios.get(`https://www.asinova.es/webapi/api/Usuarios/${log.id}`)
        .then(res=>{
          setPerfil(res.data.perfil!=null?res.data.perfil:null)
          if (log.perfil!=res.data.perfil){
            localStorage.setItem("log",JSON.stringify(res.data))
          }
        })
        .catch(error=>{
          setLog(null)
          localStorage.removeItem("log")
          navigate('/grp/iniciar-sesión')
        })
    }
    if (reemplazarAcentos(location.pathname).replace("/grp/","")=="cerrar-sesión"){
      setLog(null)
      localStorage.removeItem("log")
      navigate('/grp/iniciar-sesión')
    }
    if (location.pathname=="/grp/datos-usuario"){
      if (log==null || log.nombre==null){
        navigate('/grp/iniciar-sesión')
      }
    }
    }
  })
  const onClick=()=>{
    setShow(!show)
    if (!show==false){
      setSubShow(false)
    }
  }
  const onSubClick=()=>{
    setSubShow(!subshow)
  }
  const onChangeLocation=(en)=>{
    setShow(false)
    setSubShow(false)
    navigate("/"+en)
  }
  let sublinks=Array.from({length:subenlaces.length},(_,i)=>(
    <div className='sublink-mobil' style={{display:'flex',alignItems:'center',backgroundImage:reemplazarAcentos(location.pathname).includes("/"+url(subenlaces[i]))?'linear-gradient(gray,white,gray)':'linear-gradient(black,black,black)',color:reemplazarAcentos(location.pathname).includes("/"+url(subenlaces[i]))?'black':'white',borderBottom:'1px solid white'}}><a key={i} style={{padding:'1rem',display:'block',width:'100%'}} onClick={()=>onChangeLocation("productos-y-servicios/"+url(subenlaces[i]))}>{idioma=="en"?subenlaces_en[i].replace(" "," - "):subenlaces[i].replace(" "," - ")}</a></div>
  ))
  let links=Array.from({length:enlaces.length},(_,i)=>(
    <>
      <div className='link-mobil' style={{display:'flex',alignItems:'center',backgroundImage:reemplazarAcentos(location.pathname).includes("/"+url(enlaces[i])) || (i==0 && location.pathname.replace("/","").length==0)?'linear-gradient(goldenrod,yellow,goldenrod)':'linear-gradient(black,black,black)',color:reemplazarAcentos(location.pathname).includes("/"+url(enlaces[i])) || (i==0 && location.pathname.replace("/","").length==0)?'black':'gold',borderBottom:'1px solid gold'}}><a key={i} style={{padding:'1rem',display:'block',width:'100%'}} onClick={()=>onChangeLocation(url(enlaces[i]))}>{idioma=="en"?enlaces_en[i]:enlaces[i]}</a>{enlaces[i]=='Productos y Servicios'?<a style={{display:'block',padding:'1rem',width:'3%',textAlign:'center',margin:'0.5rem',transform:subshow?'rotate(90deg)':''}} onClick={()=>onSubClick()}>►</a>:null}</div>
      {enlaces[i]=="Productos y Servicios" && subshow?
      <div>
        {sublinks}
      </div>
      :null
      }
    </>
  ))
  return (
    <div className="App">
      {grp?
      <>
        <header>
          <EnlacesGRP enlaces={enlaces_grp} enlaces_en={enlaces_grp}/>
          <div className='flex' style={{alignItems:'center',justifyContent:'center'}}>
            {log!=null?
              <div>
                <div className='flex mid useroptions' onClick={()=>{setUseroptions(!useroptions)}}>
                  <p style={{lineHeight:0,margin:0}}>{log.nick}</p>
                  <img src={perfil!=null?`data:image/*;base64,${perfil}`:ic_user} style={{width:'50px', height:'50px',borderRadius:'50%',cursor:'pointer'}} className='perfil-cabecera'/>
                </div>{useroptions?<div style={{display:'block',position:'absolute',backgroundColor:'black'}} className='useroptionsbox'>
                  <a href='/grp/datos-usuario'>Datos de Usuario</a>
                  <a onClick={()=>{setUseroptions(false);setLog(null);localStorage.removeItem("log");navigate('/grp/iniciar-sesión')}}>Cerrar Sesión</a>
                </div>:null}
              </div>:null
            }
            <a style={{lineHeight:0}} href='/grp'><img src={logo} className="logo borde-blanco-saturado"/></a>
          </div>
        </header>
        <main ref={mainRef}>
            {location.pathname=="/grp/datos-usuario"?<DatosUsuario usuario={log} setUsuario={setLog} setPerfilArriba={setPerfil}/>:grpages[enlaces_grp.findIndex(e=>reemplazarAcentos(location.pathname).includes("/"+url(e)) || (location.pathname.replace("/grp","").length<=1 && e==enlaces_grp[0]))]}
        </main>
      </>
      :
      <>
        <header>
          <div ref={linksicon} className='round-links-icon' onClick={()=>onClick()}>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <Enlaces enlaces={enlaces} enlaces_en={enlaces_en}/>
          <div className='flex' style={{alignItems:'center',justifyContent:'center'}}>
            <div className='flex min600' style={{margin:'0.5rem 0'}}>
              <img src={es} className='bandera' onClick={()=>{localStorage.setItem("idioma","es");window.location.reload();}} style={{cursor:'pointer',boxShadow:idioma=="es"?"0 0 0 0.1rem black, 0 0 0 0.22rem white":"none"}}/>
              <img src={en} className='bandera' onClick={()=>{localStorage.setItem("idioma","en");window.location.reload();}} style={{cursor:'pointer',boxShadow:idioma=="en"?"0 0 0 0.1rem black, 0 0 0 0.22rem white":"none"}}/>
            </div>
            <a style={{lineHeight:0}} href='/inicio'><img src={logo} className="logo borde-blanco-saturado"/></a>
          </div>
        </header>
        {show?<div>{links}</div>:null}
        <main ref={mainRef}>
          <div style={{margin:'0 auto'}}>
            <a href='/inicio'><img src={logo} className='borde-blanco-saturado' style={{width:'70vmin',margin:'0 auto',display:'block'}}/></a>
            <h1 style={{marginTop:0,textAlign:'center',fontSize:'2vw',lineHeight:0}} className='borde-dorado subtitulo'>INDUSTRIAL SOFTWARE & AUTOMATION</h1>
          </div>
          <div className='pagina'>
            {location.pathname=="/sitemap" || location.pathname=="/sitemap/"?<Mapa enlaces={enlaces} enlaces_en={enlaces_en} subenlaces={subenlaces} subenlaces_en={subenlaces_en}/>:enlaces.find(e=>reemplazarAcentos(location.pathname).includes("/"+url(e)))==null && location.pathname.replace("/","").length>0?<NoEncontrado/>:pages[enlaces.findIndex(e=>reemplazarAcentos(location.pathname).includes("/"+url(e)) || (enlaces.indexOf(e)==0 && location.pathname.replace("/","").length==0))]}
          </div>
          <div className='footer flex min600'>
            <div className='flex min600'><div>{idioma=="en"?'© ASINOVA SOLUTIONS, S.L.':"© ASINOVA SOLUCIONES, S.L."}</div><div className='visible600' style={{padding:'0 1rem'}}> | </div><a href="/sitemap" style={{color:'white'}}>{idioma=="en"?"Site Map":"Mapa del Sitio"}</a></div><a href='https://login.ionos.es/?redirect_url=https%3A%2F%2Fmy.ionos.es%2Fmywebsite-overview%3Fmywebsite.pageid%3D1433105&username=www.asinova.es' style={{color:'white'}}>{idioma=="en"?"Login":"Iniciar Sesión"}</a>
          </div>
        </main>
      </>
      }
    </div>
  );
}
export default App;